import type { Field } from "@certa/types";

export const shouldRenderField = (field: Field) => {
  const isHiddenDepedentField =
    field.definition?.hidden && field.definition.extra.dependent_field === true;
  return !isHiddenDepedentField;
};
